import { Colors } from '@oy/uicore';
import { colorToRgb } from './color';

type InputMessageIcon = 'error';

export const getMessageIconUrl = (
  icon: InputMessageIcon,
  color?: Colors,
): string => {
  const iconColor = encodeURIComponent(color ?? Colors.BLACK100);
  switch (icon) {
    case 'error':
      return `data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' style='color:${iconColor}' fill='none' stroke='currentColor'%3E%3Ccircle cx='6' cy='6' r='4.5'/%3E%3Cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3E%3Ccircle cx='6' cy='8.2' r='.6' fill='currentColor' stroke='none'/%3E%3C/svg%3E`;
    default:
      return '';
  }
};

export const getCustomMessageCSSProperties = (
  params?: {
    color?: Colors;
    icon?: 'error';
  } | null,
) => {
  const properties: Record<string, any> = {};
  if (params && params.color) {
    properties['--custom-message-color'] = params.color;

    const rgb = colorToRgb(params.color);
    if (rgb) {
      properties['--custom-message-color-rgb'] = `${rgb.r} ${rgb.g} ${rgb.b}`;
    }
  }
  return properties;
};
